/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HeightUpsertRequestDto } from './HeightUpsertRequestDto';
import {
    HeightUpsertRequestDtoFromJSON,
    HeightUpsertRequestDtoFromJSONTyped,
    HeightUpsertRequestDtoToJSON,
    HeightUpsertRequestDtoToJSONTyped,
} from './HeightUpsertRequestDto';
import type { WeightUpsertRequestDto } from './WeightUpsertRequestDto';
import {
    WeightUpsertRequestDtoFromJSON,
    WeightUpsertRequestDtoFromJSONTyped,
    WeightUpsertRequestDtoToJSON,
    WeightUpsertRequestDtoToJSONTyped,
} from './WeightUpsertRequestDto';

/**
 * 
 * @export
 * @interface UpdateGeneralInformationRequestDto
 */
export interface UpdateGeneralInformationRequestDto {
    /**
     * Gender
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    gender: string;
    /**
     * First name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    firstName: string;
    /**
     * Middle name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    middleName?: string;
    /**
     * Last name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    lastName: string;
    /**
     * Birth date
     * @type {Date}
     * @memberof UpdateGeneralInformationRequestDto
     */
    birthDate: Date;
    /**
     * Primary care phone
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    primaryCarePhone: string;
    /**
     * Phone
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    phone: string;
    /**
     * Emergency contact name
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    emergencyContactName: string;
    /**
     * Emergency contact phone
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    emergencyContactPhone: string;
    /**
     * Weight
     * @type {WeightUpsertRequestDto}
     * @memberof UpdateGeneralInformationRequestDto
     */
    weight: WeightUpsertRequestDto;
    /**
     * Height
     * @type {HeightUpsertRequestDto}
     * @memberof UpdateGeneralInformationRequestDto
     */
    height: HeightUpsertRequestDto;
    /**
     * Profile image URL
     * @type {string}
     * @memberof UpdateGeneralInformationRequestDto
     */
    photoUrl?: string;
    /**
     * Indicates if this update is part of onboarding flow
     * @type {boolean}
     * @memberof UpdateGeneralInformationRequestDto
     */
    isOnboarding?: boolean;
}

/**
 * Check if a given object implements the UpdateGeneralInformationRequestDto interface.
 */
export function instanceOfUpdateGeneralInformationRequestDto(value: object): value is UpdateGeneralInformationRequestDto {
    if (!('gender' in value) || value['gender'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('birthDate' in value) || value['birthDate'] === undefined) return false;
    if (!('primaryCarePhone' in value) || value['primaryCarePhone'] === undefined) return false;
    if (!('phone' in value) || value['phone'] === undefined) return false;
    if (!('emergencyContactName' in value) || value['emergencyContactName'] === undefined) return false;
    if (!('emergencyContactPhone' in value) || value['emergencyContactPhone'] === undefined) return false;
    if (!('weight' in value) || value['weight'] === undefined) return false;
    if (!('height' in value) || value['height'] === undefined) return false;
    return true;
}

export function UpdateGeneralInformationRequestDtoFromJSON(json: any): UpdateGeneralInformationRequestDto {
    return UpdateGeneralInformationRequestDtoFromJSONTyped(json, false);
}

export function UpdateGeneralInformationRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateGeneralInformationRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'gender': json['gender'],
        'firstName': json['firstName'],
        'middleName': json['middleName'] == null ? undefined : json['middleName'],
        'lastName': json['lastName'],
        'birthDate': (new Date(json['birthDate'])),
        'primaryCarePhone': json['primaryCarePhone'],
        'phone': json['phone'],
        'emergencyContactName': json['emergencyContactName'],
        'emergencyContactPhone': json['emergencyContactPhone'],
        'weight': WeightUpsertRequestDtoFromJSON(json['weight']),
        'height': HeightUpsertRequestDtoFromJSON(json['height']),
        'photoUrl': json['photoUrl'] == null ? undefined : json['photoUrl'],
        'isOnboarding': json['isOnboarding'] == null ? undefined : json['isOnboarding'],
    };
}

export function UpdateGeneralInformationRequestDtoToJSON(json: any): UpdateGeneralInformationRequestDto {
    return UpdateGeneralInformationRequestDtoToJSONTyped(json, false);
}

export function UpdateGeneralInformationRequestDtoToJSONTyped(value?: UpdateGeneralInformationRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gender': value['gender'],
        'firstName': value['firstName'],
        'middleName': value['middleName'],
        'lastName': value['lastName'],
        'birthDate': ((value['birthDate']).toISOString()),
        'primaryCarePhone': value['primaryCarePhone'],
        'phone': value['phone'],
        'emergencyContactName': value['emergencyContactName'],
        'emergencyContactPhone': value['emergencyContactPhone'],
        'weight': WeightUpsertRequestDtoToJSON(value['weight']),
        'height': HeightUpsertRequestDtoToJSON(value['height']),
        'photoUrl': value['photoUrl'],
        'isOnboarding': value['isOnboarding'],
    };
}

